const qs = require('querystring');
import API from './index';

// sel-cateid=0&limit=15&offset=0&order=desc&sort=&sel-status=1&key=
export function getNewsList({
  category,
  limit,
  offset,
  order,
  sort,
  status,
  keyword,
} = {}) {
  return API.get('news/QueryNewsInfoList', {
    params: {
      'sel-cateid': category,
      limit,
      offset,
      order,
      sort,
      'sel-status': status,
      key: keyword,
    },
  }).then(res => res.data);
}

export function queryNews(orgId, type, count) {
  return API.post(
    '/news/QueryNews',
    qs.stringify({
      orgId: orgId,
      type: type == undefined ? -1 : type,
      count: count == undefined ? 3 : count,
    })
  ).then(res => res.data);
}
export function getNewsCateList() {
  return API.get('/news/getNewsCateList').then(res => res.data);
}

export function getNewsInfo(id) {
  return API.get('/news/GetNewsInfo', {
    params: {
      id,
    },
  }).then(res => res.data);
}

export function getNewsInfoByKey(key) {
  return API.get('/news/GetNewsInfo', {
    params: {
      flag: key,
    },
  }).then(res => res.data);
}
//特色服务
export function getProjectList(maxCount) {
  return API.get('/project/queryProject', {
    params: {
      max: maxCount == undefined ? 6 : maxCount,
    },
  }).then(res => res.data);
}

export function getProjectInfo(id) {
  return API.post(
    '/project/GetProjectByID',
    qs.stringify({
      projectid: id,
    })
  ).then(res => res.data);
}
export function getProjectTypeList() {
  return API.get('/project/GetProjectTypeList').then(res => res.data);
}

//主营业务，
export function getServiceList(maxCount) {
  return API.get('/service/QueryServiceList', {
    params: {
      max: maxCount == undefined ? 6 : maxCount,
    },
  }).then(res => res.data);
}
export function getServiceInfoWithID(id) {
  return API.get('/service/getServiceInfoWithID', {
    params: {
      id: id,
    },
  }).then(res => res.data);
}

export function getLastMess() {
  return API.get('/message/GetLastMess').then(res => res.data);
}

export function queryMessageList(maxCount) {
  return API.get('/message/QueryMessageList', {
    params: {
      max: maxCount == undefined ? 6 : maxCount,
    },
  }).then(res => res.data);
}

export function getMessInfoSetRead(msid) {
  return API.get('/message/getMessInfoSetRead?msid=' + msid).then(
    res => res.data
  );
}

export function getUnReadMsgCount() {
  return API.get('/message/GetUnReadMsgCount').then(res => res.data);
}

export function getLastNotify(orgId) {
  return API.get('/notify/GetLastNotify?orgId=' + orgId).then(res => res.data);
}

export function getNotifyList(maxCount) {
  return API.get('/notify/GetNotifyList', {
    params: {
      max: maxCount == undefined ? 6 : maxCount,
    },
  }).then(res => res.data);
}

/**
 * 根据通知 ID 获取通知信息
 * @param {number} id - 通知的唯一标识符
 * @returns {Promise<Object>} - 包含通知信息的 Promise 对象
 */
export function getNotifyInfo(id) {
  return API.get('/notify/GetNotifyInfo', {
    params: {
      id: id,
    },
  }).then(res => res.data);
}

/**
 * 获取公司信息
 * @returns {Promise<Object>} - 包含公司信息的 Promise 对象
 */
export function getFirmInfo() {
  return API.get('/firm/GetFirmInfo').then(res => res.data);
}

/**
 * 根据配置键获取系统配置信息
 * @param {string} cfgKey - 系统配置的键
 * @returns {Promise<Object>} - 包含系统配置信息的 Promise 对象
 */
export function getSysConf(cfgKey) {
  return API.get('/common/GetSysConf?key=' + cfgKey).then(res => res.data);
}

/**
 * 执行翻译操作
 * @param {string} origin - 需要翻译的原文
 * @param {string} toLang - 目标语言
 * @returns {Promise<Object>} - 包含翻译结果的 Promise 对象
 */
export function translateAction(origin, toLang) {
  return API.get(
    '/translate/TransTo?origin=' + origin + '&lang=' + toLang
  ).then(res => res.data);
}

/**
 * 执行获取机构信息操作
 * @param {string} url - 需要翻译的原文
 * @returns {Promise<Object>} - 包含翻译结果的 Promise 对象
 */
export function getOrgInfoByUrl(url) {
  return API.get('/firm/GetOrgInfoByUrl?key=' + url).then(res => res.data);
}

/**
 * 执行获取机构信息操作
 * @param {string} url - 需要翻译的原文
 * @returns {Promise<Object>} - 包含翻译结果的 Promise 对象
 * */
export function getCommonConfList(orgId) {
  return API.get('/price/GetCommonConfList?orgId=' + orgId).then(
    res => res.data
  );
}

/*
 * 根据条件查询价格表
 * */
export function getPriceStaList({
  lineId: lineId,
  memberTypeId: memberTypeId,
  bizTypeId: bizTypeId,
  senseTypeId: senseTypeId,
}) {
  return API.post(
    '/price/getPriceStaList',
    qs.stringify({
      lineId: lineId,
      memberTypeId: memberTypeId,
      bizTypeId: bizTypeId,
      senseTypeId: senseTypeId,
    })
  ).then(res => res.data);
}

/**
 * 获取当前的价格费用
 * @returns {Promise<Object>} - 包含价格费用信息的 Promise 对象
 * */
export function getActualPriceFee({
  strategyId: strategyId,
  priceVol: priceVol,
  priceWeight: priceWeight,
  weiVol: weiVol,
}) {
  return API.get('/price/GetActualPriceFee', {
    params: {
      strategyId: strategyId,
      priceVol: priceVol,
      priceWeight: priceWeight,
      weiVol: weiVol,
    },
  }).then(res => res.data);
}
